import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CANALI, canaleOf, STATI_POST, statoPostOf } from "@/lib/ped";

export const ChannelIcons = ({ canali = [], size = 14, mono = false, testid }) => (
  <span className="inline-flex items-center gap-1" data-testid={testid}>
    {canali.map((c) => {
      const ch = canaleOf(c);
      const I = ch.icon;
      return <I key={c} size={size} title={ch.label} style={{ color: mono ? "currentColor" : ch.color }} />;
    })}
  </span>
);

export const ChannelPicker = ({ value = [], onChange, testidPrefix = "channel" }) => (
  <div className="flex flex-wrap gap-2">
    {CANALI.map((c) => {
      const on = value.includes(c.value);
      const I = c.icon;
      return (
        <button type="button" key={c.value} data-testid={`${testidPrefix}-${c.value}`}
          onClick={() => onChange(on ? value.filter((v) => v !== c.value) : [...value, c.value])}
          className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-sm font-bold transition-colors ${on ? "text-white border-transparent" : "bg-[#A6DAFC] text-slate-600 border-slate-200 hover:border-slate-400"}`}
          style={on ? { background: c.color } : {}}>
          <I size={14} style={{ color: on ? "#fff" : c.color }} />{c.label}
        </button>
      );
    })}
  </div>
);

export const PostStatoBadge = ({ stato }) => {
  const s = statoPostOf(stato);
  return <span className={`inline-flex rounded-full border px-2.5 py-0.5 text-xs font-bold ${s.cls}`} data-testid="post-stato-badge">{s.label}</span>;
};

export const PostStatoSelect = ({ post, onChange }) => {
  const s = statoPostOf(post.stato);
  return (
    <Select value={post.stato} onValueChange={(v) => onChange(post, v)}>
      <SelectTrigger className={`h-8 w-[140px] rounded-full border text-xs font-bold ${s.cls}`} data-testid={`post-status-select-${post.id}`}><SelectValue /></SelectTrigger>
      <SelectContent>{STATI_POST.map((x) => <SelectItem key={x.value} value={x.value}>{x.label}</SelectItem>)}</SelectContent>
    </Select>
  );
};
